import React, { useEffect } from "react";
import useAxios from "axios-hooks";
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
} from "@fluentui/react";

const PostModal = ({
  showModal,
  toggleShowModal,
  onPost,
  setErrorMsg,
  setShowError,
  setShowSuccess,
  postUrl,
  postBody,
  postParams,
  title = "Warning",            
  subText = "Are you sure you want to add this item?",
  postButtonText = "Add",  
  cancelButtonText = "Cancel",   
  errorMessage = "An error occurred. Please try again.", 
}) => {
  const [{ data, loading, error }, executePost] = useAxios(
    {
      method: "Post",
      url: postUrl,
    },
    { manual: true }
  );

  useEffect(()=>{
      if(!loading && data && !error){
          onPost && onPost();
          toggleShowModal();
      }
  },[loading, data, error])

  return (
    <Dialog
      hidden={!showModal}
      onDismiss={toggleShowModal}
      modalProps={{
        isBlocking: true,
      }}
      dialogContentProps={{
        type: DialogType.normal,
        title: title, 
        subText: subText, 
      }}
    >
      <DialogFooter>
        <PrimaryButton
          onClick={async () => {
            const result = await executePost({
              data: postBody || undefined,
              params: postParams || undefined,
            });
            if (!result.isAxiosError) {
              toggleShowModal(); 
              setShowSuccess(true); 
              setTimeout(() => {
                setShowSuccess(false); 
                window.location.reload(); 
              }, 2000);
            } else {
              setShowError(true); 
              setErrorMsg(errorMessage); 
            }
          }}
          text={postButtonText} 
        />
        <DefaultButton
          loading={loading} 
          onClick={toggleShowModal} 
          text={cancelButtonText} 
        />
      </DialogFooter>
    </Dialog>
  );
};

export default PostModal;